// extracted by mini-css-extract-plugin
export var container = "styles-module--container--5d74b";
export var position = "styles-module--position--51551";
export var swipeRight = "styles-module--swipe-right--209fc";
export var textContent = "styles-module--textContent--54a03";
export var textPadding = "styles-module--textPadding--09663";
export var variant1 = "styles-module--variant1--0497f";
export var variant2 = "styles-module--variant2--f4ec3";